module.exports = __webpack_public_path__ + "media/images/icon_toggle_up-40c521e8baa0f60161dc3b8ec78576f5.png";